// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"28ddf12a","311":"8cfccb82","379":"42c1b5ee","482":"56bee78f","545":"2cff8289","975":"4d4e91e4","997":"825a048f"}[chunkId] + ".chunk.js";
};